export default "__VITE_ASSET__jE0kCUva__"